"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURP_PATTERN = void 0;
exports.validateCURP = validateCURP;
exports.normalizeCURP = normalizeCURP;
/**
 * Validates CURP (Clave Única de Registro de Población) format
 *
 * CURP is the Mexican unique population registry code.
 * Format: 18 characters (e.g., GARC850101HDFRRL09)
 * - 4 letters: surname initial + surname vowel + name initial + name letter
 * - 6 digits: birth date YYMMDD
 * - 1 letter: sex (H/M)
 * - 2 letters: state code
 * - 3 alphanumeric: consonants + check digit
 *
 * Note: This performs basic format validation only.
 *
 * @param value - CURP to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateCURP(value) {
    if (!value || !value.trim()) {
        return { isValid: false, error: 'CURP es requerido' };
    }
    const normalized = value.toUpperCase().trim();
    // CURP format: 18 alphanumeric characters
    const curpPattern = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[0-9A-Z]\d$/;
    if (!curpPattern.test(normalized)) {
        return { isValid: false, error: 'CURP inválido. Debe tener 18 caracteres (ej: GARC850101HDFRRL09)' };
    }
    // Validate length
    if (normalized.length !== 18) {
        return { isValid: false, error: 'CURP debe tener exactamente 18 caracteres' };
    }
    return { isValid: true };
}
/**
 * Normalizes CURP to uppercase and trimmed
 *
 * @param value - CURP to normalize
 * @returns Normalized CURP
 */
function normalizeCURP(value) {
    return value.toUpperCase().trim();
}
/**
 * Regex pattern for CURP validation
 * Can be used directly in form libraries that accept regex
 */
exports.CURP_PATTERN = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[0-9A-Z]\d$/;
